"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMapProvider = void 0;
const api_1 = require("@react-google-maps/api");
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_map_default_center_context_1 = require("./fdr-map-default-center.context");
const fdr_map_loader_1 = require("./fdr-map-loader");
const fdr_map_config_1 = require("./fdr-map.config");
const fdr_map_constants_1 = require("./fdr-map.constants");
const fdr_map_styles_1 = require("./fdr-map.styles");
const FdrMapAbsoluteLoader = (0, styled_components_1.default)(fdr_map_loader_1.FdrMapLoader)({
    position: 'absolute',
});
const MAP_LIBRARIES = [`places`];
function FdrMapProvider(props) {
    const { mapRef, options, styles, onLoad, children, className } = props, mapProps = __rest(props, ["mapRef", "options", "styles", "onLoad", "children", "className"]);
    const [, { language }] = (0, next_i18next_1.useTranslation)();
    const providedDefaultCenter = (0, fdr_map_default_center_context_1.useFdrMapDefaultCenter)();
    const { center: centerProp = providedDefaultCenter || fdr_map_constants_1.defaultCenter } = props;
    // Prevent changing center if lat & lng are not changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const center = (0, react_1.useMemo)(() => centerProp, [centerProp.lat, centerProp.lng]);
    const onLoadHandler = (0, react_1.useCallback)(map => {
        if (onLoad) {
            onLoad(map);
        }
        if (mapRef) {
            mapRef.current = map;
        }
    }, [mapRef, onLoad]);
    return (react_1.default.createElement(api_1.LoadScriptNext, { googleMapsApiKey: fdr_map_config_1.googleMapKey, version: fdr_map_config_1.googleMapVersion, loadingElement: react_1.default.createElement(fdr_map_loader_1.FdrMapLoader, null), language: language, preventGoogleFontsLoading: true, libraries: MAP_LIBRARIES },
        react_1.default.createElement(fdr_map_styles_1.FdrMapWrapper, { className: className },
            react_1.default.createElement(FdrMapAbsoluteLoader, null),
            react_1.default.createElement(api_1.GoogleMap, Object.assign({ zoom: 3, center: center }, mapProps, { options: Object.assign(Object.assign({}, fdr_map_constants_1.mapOptions), options), mapContainerStyle: Object.assign({ position: 'absolute', background: 'transparent' }, styles), onLoad: onLoadHandler }), children))));
}
exports.FdrMapProvider = FdrMapProvider;
//# sourceMappingURL=fdr-map-provider.js.map